export default "__VITE_ASSET__c9c5dde5__"